import { TransformNode } from "@babylonjs/core/Meshes/transformNode";

export default class OrbitalMesh extends TransformNode {
  constructor(name, scene) {
    super(name, scene);
    this.meshes = [];
  }

  set geometricMeshes(meshes) {
    this.meshes = meshes;
  }

  get geometricMeshes() {
    return this.meshes;
  }

  set isVisible(visibility) {
    // console.log(`Setting visibility for ${this.name} to ${visibility}`);
    this.meshes.forEach(mesh => mesh.isVisible = visibility);
  }

  get isVisible() { return this.meshes[0].isVisible; }

  set isPickable(pickability) {
    // console.log(`Setting pickability for ${this.name} to ${pickability}`);
    this.meshes.forEach(mesh => mesh.isPickable = pickability);
  }

  get isPickable() { return this.meshes[0].isPickable; }
}
